import { useSearchParams } from 'react-router-dom';
import { SegmentedTabs } from '@/components/ui/SegmentedTabs';

export const CONTENT_STATUS_OPTIONS = [
  { value: 'all', label: 'Wszystkie' },
  { value: 'published', label: 'Opublikowane' },
  { value: 'draft', label: 'Szkice' },
  { value: 'trash', label: 'Kosz' },
] as const;
export type ContentStatusFilter = typeof CONTENT_STATUS_OPTIONS[number]['value'];

export function useContentStatusFilter() {
  const [params, setParams] = useSearchParams();
  const status = CONTENT_STATUS_OPTIONS.find(option => option.value === params.get('status'))?.value ?? 'all';
  return {
    status,
    setStatus: (value: ContentStatusFilter) => setParams(current => {
      const next = new URLSearchParams(current);
      if (value === 'all') next.delete('status'); else next.set('status', value);
      next.delete('page');
      return next;
    }),
    pageStatus: status === 'all' ? undefined : status === 'published' ? 'PUBLISHED' : status === 'draft' ? 'DRAFT' : 'TRASHED',
    wpStatus: status === 'all' ? 'any' : status === 'published' ? 'publish' : status,
  };
}

export function ContentStatusTabs({ value, onChange }: { value: ContentStatusFilter; onChange: (value: ContentStatusFilter) => void }) {
  return <div className="overflow-x-auto mb-4"><SegmentedTabs aria-label="Status treści" value={value} onChange={onChange} options={[...CONTENT_STATUS_OPTIONS]} /></div>;
}
